export default function productTransformer(
  product,
  amount = 1,
  price = 0,
  priceVat = 0,
  index = 0,
  colour = null,
  masterItemIdFallback = null,
) {
  if (!product) return null

  // Availability mapping
  const availabilityMap = {
    'in-stock': 'in_stock',
    'out-of-stock': 'out_of_stock',
    'sold-out': 'out_of_stock',
    'pre-order': 'preorder',
    discontinued: 'out_of_stock',
    'in-store-only': 'in_stock',
    limited: 'in_stock',
    'online-only': 'in_stock',
  }

  // Parse categories dynamically
  const parsedCategories = parseCategoryHierarchy(product.categoryFullname)
  // Determine stock condition
  const stockCondition = availabilityMap[(product.availability?.availabilityCode)] || 'out_of_stock'
  // Determine item variant id
  const itemVariantId = `${product.attributes?.width}${product.attributes?.height}`
  const masterItemId = resolveMasterItemId(product, masterItemIdFallback)

  return {
    item_id: product.id + (colour ? `1${colour}` : ''),
    master_item_id: masterItemId,
    item_group_id: product.productId,
    item_name: product.name,
    affiliation: 'SMART OknaDveřeNaMíru',
    coupon: '', // TODO: add value for the coupon
    discount: 0.0, // TODO: apply discount value
    index: index,
    item_brand: 'SMART OknaDveřeNaMíru',
    item_category_full: product.categoryFullname || '',
    ...parsedCategories,
    google_category: product.attributes?.google?.fullname,
    heureka_category: product.attributes?.heureka?.fullname,
    zbozi_category: product.attributes?.zbozi?.fullname,
    item_list_id: product.categoryName || '',
    item_list_name: product.categoryName || '',
    item_variant: itemVariantId,
    location_id: 'ChIJsTwWAozDEkcRpmawzxKIcWM',
    mkt_val: price || product.prices?.unitWithoutTax || 0,
    stock_cond: stockCondition,
    price: price || product.prices?.unitWithoutTax || 0,
    price_vat: priceVat || product.prices?.unitWithTax || 0,
    quantity: amount,
  }
}

function filledString(value) {
  if (value === null || value === undefined || value === '') {
    return null
  }

  return `${value}`
}

function resolveMasterItemId(product, fallback = null) {
  const cmsId = Array.isArray(product.attributes?.cms_ids) ? product.attributes.cms_ids[0] : null

  return (
    filledString(fallback) ||
    filledString(cmsId) ||
    filledString(product.productId) ||
    filledString(product.id) ||
    'unknown'
  )
}

/**
 * Function to parse category hierarchy dynamically
 */
function parseCategoryHierarchy(categoryFullname) {
  const categories = categoryFullname ? categoryFullname.split('>').map(cat => cat.trim()) : []

  return {
    item_category1: categories[0] || '',
    item_category2: categories[1] || '',
    item_category3: categories[2] || '',
    item_category4: categories[3] || '',
    item_category5: categories[4] || '',
  }
}
